import { useContext } from 'react'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom'

import NewUpload from '../../components/uploads/new'
import UploadList from '../../components/uploads/list'
import ViewUpload from '../../components/uploads/view'
import AuthContext, { initialAuth } from '../../context/AuthContext'
import { ON_HOLD } from '../../utils/dealers'

type TAuth = typeof initialAuth & {
  membership: typeof initialAuth.membership & {
    dealer: typeof initialAuth.membership.dealer & {
      status: string | null
    }
  }
}
type TSetAuth = (updates: Partial<TAuth>) => void

const Upload = () => {
  const [auth] = useContext(AuthContext) as unknown as [TAuth, TSetAuth]
  const location = useLocation()

  return (
    <Switch>
      <Route
        path={[
          '/uploads/list/ready',
          '/uploads/list/in-progress',
          '/uploads/list/downloaded',
          '/uploads/list/re-credited',
          '/uploads/list/pending',
          '/uploads/list/on-hold',
          '/uploads/list/all',
        ]}
        render={(props) => <UploadList isAdmin={false} {...props} />}
      />
      {auth.membership.dealer.status !== ON_HOLD && (
        <Route path="/uploads/new" component={NewUpload} />
      )}
      <Route path="/uploads/view/:uploadId" component={ViewUpload} />
      <Redirect to={{ pathname: '/uploads/list/all', state: location.state }} />
    </Switch>
  )
}

export default Upload
